import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/MessageBar")
);

const MessageBarEditConfig = {
  emptyLabel: "Message Bar",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = ({ url, badgePosition, ...props }) => {
  return {
    component: "MessageBar",
    props: {
      href: url,
      position: badgePosition,
      ...props,
    },
  };
};

const MessageBar = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/message-bar")(
  MessageBar,
  MessageBarEditConfig
);
